import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FadeInOnScrollDirective } from './fade-in-on-scroll.directive';

@NgModule({
  declarations: [FadeInOnScrollDirective],
  imports: [CommonModule],
  exports: [FadeInOnScrollDirective]
})
export class FadeInOnScrollModule { }
